import { apiClient } from "./ApiClient";

/**
 * Fetch list of available payment providers (e.g. Stripe, PayPal).
 * @returns {Promise<{ total: number, items: Array<{ name: string, code: string }> }>}
 */
export async function fetchAvailableProviders() {
  try {
    const res = await apiClient.get("/payment/available-providers");
    return res.data;
  } catch (error) {
    const err = new Error("Failed to load available payment providers");
    err.status = error.response?.status;
    err.response = {
      status: error.response?.status,
      data: error.response?.data,
    };
    throw err;
  }
}
